import { not, rule } from '../../domain/badge-composition-rule.js';
import { i18n } from '../../domain/i18n.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const brandSponsoredRules = composition => {
  const { check, planIsAtLeast, isTuvVerified, isBS } = composition.checkers;

  return [
    rule('brand-sponsored/adjustments')
      .when(planIsAtLeast('start'))
      .when(isTuvVerified)
      .set(() => ({
        parts: {
          tuvSeal: {
            showInAccordion: true, // changed approach to accordion (when to show tuv) so need this extra flag to force show on e.g. footer
          }
        }
      })),

    rule('brand-sponsored/texts')
      .when(check(() => composition.input.product && composition.input.product.brandSponsored))
      .set(() => ({
        parts: {
          contents: {
            texts: {
              shopCheckTitle: i18n.contents.texts.shopCheckTitle_brandSponsored,
              shopCheckText: i18n.contents.texts.shopCheckText_brandSponsored
            }
          },
        }
      })),

    rule('brand-sponsored/seal')
      .when(not(isTuvVerified).and(isBS))
      .set(() => ({
        flags: {
          'brand-sponsored': true
        },
        parts: {
          tuvSeal: {
            show: false,
          }
        }
      })),

    rule('brand-sponsored/premium+notuv')
      .when(planIsAtLeast('premium'))
      .when(not(isTuvVerified))
      .set(() => ({
        flags: {
          'brand-sponsored': true
        },
        parts: {
          tuvSeal: {
            show: false,
          }
        }
      }))
  ];
};
